import { Injectable } from '@angular/core';
import { StoreBase } from '../../shared/models/bases/storeBase';
import { BusinessType } from '../../shared/models/business/businessType';

@Injectable({providedIn: 'root'})
export class BusinessTypeStore extends StoreBase<BusinessType> { }
